import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { AuthConstants } from 'src/app/config/auth-constants';
import { StoreService } from 'src/app/services/store.service'
import { HelperService } from 'src/app/services/helper.service';
import { ActionSheetController, Platform, NavController, IonRouterOutlet } from '@ionic/angular';

@Component({
  selector: 'app-order-confirm',
  templateUrl: './order-confirm.page.html',
  styleUrls: ['./order-confirm.page.scss'],
})
export class OrderConfirmPage implements OnInit {

  transactionId: any;
  constructor(
    private platform: Platform,
    private router: Router,
    private routerOutlet: IonRouterOutlet,
    private routerActivate: ActivatedRoute,
    private navController: NavController) {
    let that = this;
    this.platform.ready().then(() => {

      // this.platform.backButton.subscribeWithPriority(9999, () => {

      // if (this.router.url === '/order-confirm'){
      //   document.addEventListener('backbutton', function (event) {
      //     event.preventDefault();
      //     event.stopPropagation();
      //     console.log('hello');
      //   }, false);
      // }
      // });

      this.platform.backButton.subscribeWithPriority(9999, () => {
        console.log('hello');
        document.addEventListener('backbutton', function(event) {

          if (that.router.url.includes('order-confirm')) {
            // this.platform.exitApp(); 
          } else {
            if (that.routerOutlet && that.routerOutlet.canGoBack()) {
              that.routerOutlet.pop();
            }
          }
        }, false);
      });



    });

    this.routerActivate.queryParams.subscribe(params => {
      if (this.router.getCurrentNavigation().extras.state) {
        this.transactionId = this.router.getCurrentNavigation().extras.state.paymentId;
      }
      console.log("receive param from checkout page(transaction ID", this.transactionId)
    });
  }


  ngOnInit() {}
  viewOrder() {
    let navigationParams: NavigationExtras = { state: { paymentId: this.transactionId } };

    this.navController.navigateRoot(['/'], navigationParams)
    // this.router.navigate(['/order-history'], navigationParams);

  }
  // goBack(){
  //   this.navController.pop();
  // }
  goHome() {
    this.navController.navigateRoot('/').then(()=>{
      window.location.reload()
    })
    // this.router.navigate(['/tabs/feeds'])
  }
}
